import { SupportedLocales } from 'modules/application/types';

export const defaultLocale: SupportedLocales = 'en-CA';

function inferLocale(lang: string): SupportedLocales {
  const twoLetterLanguage = lang.substring(0, 2);

  if (twoLetterLanguage === 'en') return 'en-CA';
  if (twoLetterLanguage === 'fr') return 'fr-CA';

  return defaultLocale;
}

export const i18nMessages: Record<
  SupportedLocales,
  Record<string, string> | undefined
> = {
  'en-CA': undefined,
  'fr-CA': require('assets/locales/fr.json'),
};

export function getBrowserLocale(): SupportedLocales {
  return inferLocale(
    localStorage.getItem('language') ||
    (navigator.languages && navigator.languages[0]) || // Chrome / Firefox
    navigator.language
  );
}

export const setBrowserLocale = (locale: SupportedLocales) => {
  localStorage.setItem('language', locale);
};